module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/FIR/fir.component.html
// module id = ./src/app/FIR/fir.component.html
// module chunks = main